import { SoftwareStatus } from '@casops/store/apis/commonModels';
import { setSoftwareStatus } from '@casops/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import SingleSelectFilter from '../single-select/SingleSelectFilter';
import { FilterInputProps } from '@casops/filters/types';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { useMemo } from 'react';

const useSoftwareStatusOptions = (): DropdownItemProps<SoftwareStatus>[] => {
  const { t } = useTranslation();
  return useMemo(
    () =>
      Object.entries(SoftwareStatus).map(([key, value]) => ({
        key: value,
        value,
        stringValue: value,
        label: t(key),
      })),
    [t],
  );
};

export const SoftwareStatusFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownElement>) => {
  const { t } = useTranslation();
  return (
    <SingleSelectFilter<SoftwareStatus>
      filterName="softwareStatus"
      label={label ?? t('Fields.Filters.SoftwareStatus')}
      elementRef={elementRef}
      action={setSoftwareStatus}
      useItemsHook={useSoftwareStatusOptions}
    />
  );
};

export default SoftwareStatusFilter;
